<script setup lang="ts">
import DocumentLinkCard from '@/components/documents/DocumentLinkCard.vue'
import { useDemoMode } from '@/core/composables/company/useDemoMode'
import { useI18n } from 'vue-i18n'

defineOptions({
  name: 'Documents'
})

const { t } = useI18n()
const { isInDemoMode } = useDemoMode()
</script>

<template>
  <div class="flex flex-col gap-content">
    <p>{{ t('reports.documents.info_text') }}</p>

    <template v-if="!isInDemoMode">
      <div class="flex flex-col gap-controls">
        <h3 class="heading-4">
          {{ t('reports.documents.documents_for_refunds') }}
        </h3>

        <DocumentLinkCard
          :link="t('links.travel_expense_report')"
          :info-text="t('reports.documents.travel_refund.info_text')"
          :card-header="
            t('reports.documents.travel_refund.card_header', { year: 2025 })
          "
        />

        <DocumentLinkCard
          :link="t('links.expense_report')"
          :info-text="t('reports.documents.expense_refund.info_text')"
          :card-header="t('reports.documents.expense_refund.card_header')"
        />
      </div>

      <div class="flex flex-col gap-controls">
        <h3 class="heading-4">{{ t('reports.headings.old_documents') }}</h3>

        <DocumentLinkCard
          :link="t('links.travel_expense_report_2024')"
          :info-text="t('reports.documents.travel_refund.info_text')"
          :card-header="
            t('reports.documents.travel_refund.card_header', { year: 2024 })
          "
        />
      </div>
    </template>
  </div>
</template>
